const config = {
    id: 13,
    name: "店招",
    type: 1,
    module_code: "shop_header",
    icon: "icon-tms-shop_header",
    font_icon: "&#xe664;",
    style_type: 1,
    link_type: 0,
    property_data: {
        name: "店招名称"
    }
};
export default config